import React from 'react';
import image from '../Image/Fuad-removebg-preview.png'

const Banner = () => {
    return (
        <div class="hero ">
            <div class="hero-content flex-col lg:flex-row-reverse mx-24">
                <img src={image} class="max-w-sm rounded-lg mb-24" />
                <div>
                    <h3 className='font-bold text-primary text-2xl'>Hello</h3>
                    <h1 class="text-4xl font-bold ">I'M Fahid Hasan Fuad</h1>
                    <p class="py-6 text-white">Junior web developer, expart in react.js</p>
                    <a href='https://docs.google.com/document/d/1YbWy4TAGu0azfJMFNH49Z9ScgaVCCp14FBOHuV0v33U/edit?usp=sharing' class="btn btn-primary">Download resume</a>
                </div>
            </div>
        </div>
    );
};

export default Banner;